<div class="heading-2 break-word" mat-dialog-title>
  {{ title | translate }}
  <ng-container *ngIf="suffix">{{ suffix }}</ng-container>
  <mat-icon *ngIf="tooltip" class="svg-icon text-muted" [svgIcon]="'info'" [matTooltip]="tooltip | translate"></mat-icon>
</div>
<button mat-button class="icon-button close-dialog" *ngIf="withConfirm" (click)="closed.emit()">
  <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
</button>
<button mat-button mat-dialog-close class="icon-button close-dialog" *ngIf="!withConfirm" (click)="closed.emit()">
  <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
</button>
